import {
  BankStep,
  ConclusionStep,
  ReviewStep,
  WithdrawStep
} from '../components';

export enum EWithdrawByPortfolioSteps {
  WITHDRAW,
  BANK,
  REVIEW,
  CONCLUSION
}

export const WithdrawByPortfolioComponents = {
  [EWithdrawByPortfolioSteps.WITHDRAW]: WithdrawStep,
  [EWithdrawByPortfolioSteps.BANK]: BankStep,
  [EWithdrawByPortfolioSteps.REVIEW]: ReviewStep,
  [EWithdrawByPortfolioSteps.CONCLUSION]: ConclusionStep
};
